<template>
  <nav id="footer" class="wealth-footer">
    <router-link
      v-for="item in footerList"
      :key="item.url"
      :to="item.url"
      class="footer-item"
      :class="{ on: isActive(item) }"
    >
      <span class="footer-icon">
        <i v-if="item.icon === 'home'" class="home-shape"></i>
        <i v-else-if="item.icon === 'product'" class="product-shape"></i>
        <i v-else-if="item.icon === 'service'" class="service-shape"></i>
        <i v-else class="user-shape"></i>
      </span>
      <em>{{ item.name }}</em>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      footerList: [
        { name: "首页", icon: "home", url: "/" },
        { name: "产品", icon: "product", url: "/category" },
        { name: "客服", icon: "service", url: "/customerService" },
        { name: "我的", icon: "user", url: "/user" }
      ]
    };
  },
  methods: {
    isActive(item) {
      if (item.url === "/") return this.$route.path === "/";
      return this.$route.path.indexOf(item.url) === 0;
    }
  }
};
</script>

<style scoped>
#footer.wealth-footer {
  position: fixed;
  z-index: 50;
  right: 0;
  bottom: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 100%;
  height: 64px;
  box-sizing: border-box;
  padding: 7px 8px 6px;
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid #edf0f4;
  box-shadow: 0 -8px 24px rgba(24, 48, 83, 0.07);
  backdrop-filter: blur(12px);
}

.footer-item {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8e99a8;
  text-align: center;
  flex-direction: column;
}

.footer-item em {
  margin-top: 4px;
  font-size: 9px;
  font-style: normal;
  line-height: 1;
}

.footer-item.on {
  color: #1f65bb;
  font-weight: 700;
}

.footer-icon {
  position: relative;
  display: grid;
  width: 27px;
  height: 27px;
  place-items: center;
  border-radius: 9px;
}

.footer-item.on .footer-icon {
  background: #eaf3ff;
}

.footer-icon i {
  position: relative;
  display: block;
  width: 15px;
  height: 15px;
  color: currentColor;
}

.home-shape {
  border: 2px solid currentColor;
  border-top: 0;
  border-radius: 2px;
  transform: scale(0.75) translateY(4px);
}

.home-shape::before {
  position: absolute;
  top: -6px;
  left: 1px;
  width: 10px;
  height: 10px;
  content: "";
  border-top: 2px solid currentColor;
  border-left: 2px solid currentColor;
  transform: rotate(45deg);
}

.service-shape {
  border: 2px solid currentColor;
  border-radius: 50%;
}

.service-shape::before,
.service-shape::after {
  position: absolute;
  content: "";
}

.service-shape::before {
  right: -3px;
  bottom: -2px;
  width: 6px;
  height: 6px;
  background: currentColor;
  border-radius: 0 0 6px 0;
}

.service-shape::after {
  top: 4px;
  left: 3px;
  width: 7px;
  height: 2px;
  background: currentColor;
  border-radius: 2px;
  box-shadow: 0 4px 0 currentColor;
}

.product-shape {
  border: 2px solid currentColor;
  border-radius: 3px;
}

.product-shape::before {
  position: absolute;
  top: 3px;
  right: 3px;
  bottom: 3px;
  left: 3px;
  content: "";
  border: 1px solid currentColor;
  border-radius: 50%;
}

.user-shape::before {
  position: absolute;
  top: 0;
  left: 4px;
  width: 7px;
  height: 7px;
  content: "";
  border: 2px solid currentColor;
  border-radius: 50%;
}

.user-shape::after {
  position: absolute;
  right: 1px;
  bottom: 0;
  left: 1px;
  height: 7px;
  content: "";
  border: 2px solid currentColor;
  border-bottom: 0;
  border-radius: 8px 8px 0 0;
}

@media (min-width: 700px) {
  #footer.wealth-footer {
    right: auto;
    left: 50%;
    max-width: var(--asm-shell-width, 520px);
    transform: translateX(-50%);
  }
}
</style>
